import axios from "axios";

export const fetchProductData = async ({ skus, sku }: any) => {
  const { data } = await axios.post(`/api/products/getProductData`, {
    skus,
    sku
  });
  return data;
};
